const textProps = {
  items: ["Blue", "Green", "Teal", "Red", "Orange", "White"],
  placeholder: "Select color",
};
export default textProps;
